import React from "react";
import { useIntl } from "react-intl";
import { StyleSheet, css } from "aphrodite";
import { IconEpi } from "@cloudspire/legacy-svg-icon-library";

import theming from "@cloudspire/legacy-resources/src/constants/theming";

// components
import BaseComponent from "@cloudspire/legacy-resources/src/components/BaseComponent2";
import ConditionalWrapper from "@cloudspire/shared/components/ConditionalWrapper";
import Link from "../Link";

// contexts
import { useRouters } from "../../contexts/routers";

// constants
import {
  HOTEL_RATING_EPI_INTL_MESSAGES,
  HOTEL_RATING_EPIS,
} from "@cloudspire/shared/constants/hotel/rating";

// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";

const { useTheme } = theming;

type PropsType = {
  value: keyof typeof import("@cloudspire/shared/constants/hotel/rating").HOTEL_RATING_EPIS;
  color?: string;
  shouldAddSearchLink?: boolean;
};

const styles = StyleSheet.create({
  epi: {
    display: "inline-flex",
    flexDirection: "row",
  },
  icons: {
    lineHeight: 0,
    display: "flex",
  },
  icon: {
    marginRight: "0.3125rem",
  },
  icon__last: {
    marginRight: 0,
  },
});

const RoomRankingsEpi: React.FunctionComponent<PropsType> = (props) => {
  const { value, color, shouldAddSearchLink = false } = props;

  const theme = useTheme();
  const intl = useIntl();

  const label = intl.formatMessage(
    {
      defaultMessage: "Classement : {ranking}",
    },
    {
      ranking: intl.formatMessage(
        HOTEL_RATING_EPI_INTL_MESSAGES.byValue[value].label
      ),
    }
  );

  const epiInfo = HOTEL_RATING_EPIS[value];

  const { frontRouter } = useRouters();

  return (
    <ConditionalWrapper
      hasWrapper={shouldAddSearchLink}
      wrapper={(children) => (
        <Link
          to={generateUri({
            router: frontRouter,
            name: "App.Action.RoomList",
            parameters: {
              lang: intl.locale,
            },
            query: {
              epi: String(epiInfo.value),
            },
          })}
        >
          {children}
        </Link>
      )}
    >
      <BaseComponent aStyle={styles.epi} title={label}>
        <div
          className={css(styles.icons)}
          style={{ color: undefined !== color ? color : theme.PRIMARY_COLOR }}
        >
          {Array(epiInfo.value)
            .fill(null)
            .map((_, index) => {
              return (
                <div
                  key={index}
                  className={css(
                    styles.icon,
                    index + 1 === epiInfo.value && styles.icon__last
                  )}
                >
                  <IconEpi />
                </div>
              );
            })}
        </div>
      </BaseComponent>
    </ConditionalWrapper>
  );
};

export default RoomRankingsEpi;
